export const userConstants = {
  REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
  REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
  REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

  ADD_REQUEST: 'USERS_ADD_REQUEST',
  ADD_SUCCESS: 'USERS_ADD_SUCCESS',
  ADD_FAILURE: 'USERS_ADD_FAILURE',

  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

  RESET_PASSWORD_REQUEST: 'USERS_RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_SUCCESS: 'USERS_RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILURE: 'USERS_RESET_PASSWORD_FAILURE',

  FORGET_PASSWORD_REQUEST: 'USERS_FORGET_PASSWORD_REQUEST',
  FORGET_PASSWORD_SUCCESS: 'USERS_FORGET_PASSWORD_SUCCESS',
  FORGET_PASSWORD_FAILURE: 'USERS_FORGET_PASSWORD_FAILURE',

  LOGOUT: 'USERS_LOGOUT',

  GETALL_REQUEST: 'USERS_GETALL_REQUEST',
  GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
  GETALL_FAILURE: 'USERS_GETALL_FAILURE',

  DELETE_REQUEST: 'USERS_DELETE_REQUEST',
  DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
  DELETE_FAILURE: 'USERS_DELETE_FAILURE',

  GETBYID_REQUEST: 'USERS_GETBYID_REQUEST',
  GETBYID_SUCCESS: 'USERS_GETBYID_SUCCESS',
  GETBYID_FAILURE: 'USERS_GETBYID_FAILURE',

  UPDATE_REQUEST: 'USERS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'USERS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'USERS_UPDATE_FAILURE',

  GETALL_PAGE_REQUEST: 'USERS_GETALL_PAGE_REQUEST',
  GETALL_PAGE_SUCCESS: 'USERS_GETALL_PAGE_SUCCESS',
  GETALL_PAGE_FAILURE: 'USERS_GETALL_PAGE_FAILURE',

  ACTIVE_REQUEST: 'USERS_ACTIVE_REQUEST',
  ACTIVE_SUCCESS: 'USERS_ACTIVE_SUCCESS',
  ACTIVE_FAILURE: 'USERS_ACTIVE_FAILURE',

  BACKOFFICE_REQUEST: 'BACKOFFICE_PASSWORD_REQUEST',
  BACKOFFICE_SUCCESS: 'BACKOFFICE_PASSWORD_SUCCESS',
  BACKOFFICE_FAILURE: 'BACKOFFICE_PASSWORD_FAILURE',

  GETBYID_JUSTLOOKING_REQUEST: 'USERS_GETBYID_JUSTLOOKING_REQUEST',
  GETBYID_JUSTLOOKING_SUCCESS: 'USERS_GETBYID_JUSTLOOKING_SUCCESS',
  GETBYID_JUSTLOOKING_FAILURE: 'USERS_GETBYID_JUSTLOOKING_FAILURE',

  MAPTOOLX_REQUEST: 'MAPTOOLX_PASSWORD_REQUEST',
  MAPTOOLX_SUCCESS: 'MAPTOOLX_PASSWORD_SUCCESS',
  MAPTOOLX_FAILURE: 'MAPTOOLX_PASSWORD_FAILURE',

  LOGOUT_SESSION:'LOGOUT_SESSION'
}
